import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { AppValues, API, ApiAdmin, } from "../../Values";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
export default function AdminSetting() {
  const navigate = useNavigate();
  const [Values, SetValues] = useState("");


  //---------ShowModal----------------------------
  const [TypeModal, SetTypeModal] = useState("");
  const [ShowModal, SetShowModal] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);
  //===========Check Login ================
  LoginCheck();
  var admininfo = [];
  var AdminName = "";
  var AdminID = "";
  if (Cookies.get("admininfo")) {
    admininfo = JSON.parse(Cookies.get("admininfo"));
    AdminName = admininfo[0].Name;
    AdminID = admininfo[0].ID;
  }
  const [Orders, SetOrders] = useState([]);
  useEffect(() => {
    GetdellerOrders();
  }, []);

  //-------------------------------------------------------------
  async function GetdellerOrders() {
    try {
      const post = {
        Name: "dellerOrders",
        Action: "GetValues",
      };
      console.log(post);
      const response = await fetch(ApiAdmin + "/values.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log(data);
     SetValues(data.Valu);

     } catch (error) {
      return error;
    }
  }


  //-------------------------------------------------------------
  async function ChangedellerOrders() {
    GetdellerOrders();
    SetTypeModal("dellerOrders");
    handleShowModal();
  }

  //-------------------------------------------------------------

  const handeldellerOrders = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());

    if (window.confirm(`هل تريد الحقظ `)) {
      try {
        const response = await fetch(ApiAdmin + "/values.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          return alert(data.errors);
        }
        console.log(data.msg);
        handleCloseModal();
        // if (response.ok) {
        // } else if (response.status === 400) {
        //   return alert("errorr 400");
        // } else {
        //   return alert("can not save ");
        // }
      } catch (error) {
        console.log(error);
      }
    }
  };


  return (
    <>
      <Header_ />
      <div
        dir="rtl"
        className="row text-center m-auto"
        style={{ maxWidth: "800px" }}
      >
        <h3 className="text-orange fw-bold py-1">Setting</h3>

        {/* -------------- */}
        <div className="col-lg-4 col-md-4 col-6">
          <div className="card shadow m-1">
            <Link to="../admin/Users">
              <div className="card-body">
                <div
                  className="Icon-imgContainer "
                  style={{ color: "#55C99D", background: "#DCF5EA" }}
                >
                  <i className="fa-solid fa-user-secret mt-2"></i>
                </div>
                <h6>المستخدمين</h6>
              </div>
            </Link>
          </div>
        </div>
        {/* -------------- */}
        <div className="col-lg-4 col-md-4 col-6">
          <div className="card shadow m-1">
            <Link to="../CompanyInfo">
              <div className="card-body">
                <div
                  className="Icon-imgContainer"
                  style={{ color: "#3F83F8", background: "#CCE9FB" }}
                >
                  <i className="fa-solid fa-building mt-2"></i>
                </div>
                <h6>بيانات الشركة</h6>
              </div>
            </Link>
          </div>
        </div>
        {/* -------------- */}
        <div className="col-lg-4 col-md-4 col-6">
          <div className="card shadow m-1">
            <Link to="../Database">
              <div className="card-body">
                <div
                  className="Icon-imgContainer"
                  style={{ color: "#EF6242", background: "#FEECDC" }}
                >
                  <i className="fa-solid fa-database mt-2"></i>
                </div>
                <h6>قاعدة البيانات</h6>
              </div>
            </Link>
          </div>
        </div>
        {/* -------------- */}
        {/* <div className="col-lg-3 col-md-4 col-6">
          <div className="card shadow  m-1">
            <Link to="">
              <div className="card-body">
                <div
                  className="Icon-imgContainer"
                  style={{ color: "#E49E1B", background: "#FFFAE6" }}
                >
                  <i className="fa-sharp fa-solid fa-timeline mt-3"></i>
                </div>
                <h6>السجل</h6>
              </div>
            </Link>
          </div>
        </div> */}
        {/* -------------- */}
        {/* <div className="col-lg-3 col-md-4 col-6">
          <div className="card shadow m-1">
            <Link to="../admin/Payment">
              <div className="card-body">
                <div
                  className="Icon-imgContainer"
                  style={{ color: "#E49E1B", background: "#FFFAE6" }}
                >
                  <i className="fa-sharp fa-solid fa-timeline mt-3"></i>
                </div>
                <h6>اعداد الدفع</h6>
              </div>
            </Link>
          </div>
        </div> */}
        {/* -------------- */}
        <div className="col-lg-4 col-md-4 col-6">
          <div className="card shadow m-1">
            <Link to="../Destanse">
              <div className="card-body">
                <div
                  className="Icon-imgContainer"
                  style={{ color: "#7954AD", background: "#F0ECF5" }}
                >
                  <i className="fa-solid fa-location-dot mt-3"></i>
                </div>
                <h6>اعداد المسافات</h6>
              </div>
            </Link>
          </div>
        </div>
        {/* -------------- */}
        {/* <div className="col-lg-4 col-md-4 col-6">
          <div className="card shadow m-1">
            <Link to="../ApiSetting">
              <div className="card-body">
                <div
                  className="Icon-imgContainer"
                  style={{ color: "#CC2127", background: "#F3CDCF" }}
                >
                  <i className="fa-solid fa-map-location-dot  mt-3"></i>
                     </div>
                <h6> Google Maps</h6>
              </div>
            </Link>
          </div>
        </div> */}
        {/* -------------- */}
        <div className="col-lg-4 col-md-4 col-6">
          <div className="card shadow m-1">
            <Link to="../PayMentGetway">
              <div className="card-body">
                <div
                  className="Icon-imgContainer"
                  style={{ color: "#005F93", background: "#D4F1F8" }}
                >
                  <i className="fa-brands fa-cc-amazon-pay  mt-3"></i>
                </div>
                <h6> بوابات الدفع</h6>
              </div>
            </Link>
          </div>
        </div>
        {/* -------------- */}
        <div className="col-lg-4 col-md-4 col-6">
          <div className="card shadow m-1" onClick={() => ChangedellerOrders()}>
            <div className="card-body">
              <div
                className="Icon-imgContainer"
                style={{ color: "#005F93", background: "#D4F1F8" }}
              >
                <i className="fa-solid fa-location-dot mt-3"></i>
              </div>
              <h6> اقصى مسافة للمندوب</h6>
            </div>

          </div>
        </div>
        {/* -------------- */}


      </div>
      <ModalSHOW />
    </>
  );

  function ModalSHOW() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <h6 className="text-danger p-0 m-0" onClick={handleCloseModal}>
              X
            </h6>
            {TypeModal == "dellerOrders" && <DellerOrders />}
          </Modal.Body>
        </Modal>
      </>
    );

    function DellerOrders() {
      return (
        <>
          <form method="POST" onSubmit={handeldellerOrders}>
            <input type="hidden" name="Name" value="dellerOrders" />
            <input type="hidden" name="Title" value="لا" />
            <input type="hidden" name="Description" value="لا" />
            <input type="hidden" name="Action" value="AddValues" />
            <div className="row mt-0 px-1">
              <div className="col-12 text-center">
                <i className=" fa-solid fa-location-dot m-0 p-0 text-blue fs-1 mb-2"></i><br/>
                <h5 className="text-syan0">  مسافة اوردرات المندوب </h5>
                <span className="text-syan0">  المسافة الحالية {Values} كم</span>

           
              </div>
              <div className="col-12">
                <label htmlFor=""> المسافة</label>

                <input
                  type="number"
                  name="Valu"
                  className="form-control text-center mt-1"
                  autoComplete="off"
                />
              </div>
              <div className="col-12 text-center mx-2 mt-4 ">
                <button className="btn btn-syan fw-bold fs-6 w-100">حفظ</button>
              </div>
              <br />
            </div>
          </form>
        </>
      );
    }
  }
}
